import { TRiskLevel } from '@interfaces/riskLevels';

import useAdminRiskLevelsByProgramCode from './useAdminRiskLevelsByProgramCode';

const useAdminRiskLevelByProgramCodeAndId = (
  programCode?: number,
  riskLevelId?: TRiskLevel | null,
) => {
  const adminRiskLevels = useAdminRiskLevelsByProgramCode(programCode);
  return adminRiskLevels.find(adminRiskLevel => adminRiskLevel.riskLevelId === riskLevelId);
};

export default useAdminRiskLevelByProgramCodeAndId;
